// extracted by mini-css-extract-plugin
export var accoladesTeaserList = "AccoladesTeaserList-module--accoladesTeaserList--2C2Ou";
export var accoladesList = "AccoladesTeaserList-module--accoladesList--GArLn";
export var accoladeDate = "AccoladesTeaserList-module--accoladeDate--b34P6";
export var accoladeTitle = "AccoladesTeaserList-module--accoladeTitle--13AWe";